(function(){
  if(window.__pgFlip) return; window.__pgFlip=1;
  function wrap(btn){return btn.closest('[data-pg-flip-wrap]')||btn.parentElement;}
  function set(w,flipped){
    w.classList.toggle('is-flipped',flipped);
    var b=w.querySelector('[data-pg-flip]'); if(!b) return;
    b.textContent=flipped?b.dataset.labelB:b.dataset.labelA;
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-pg-flip]'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    var w=wrap(b); w.dataset.pgPinned=1; set(w,!w.classList.contains('is-flipped'));
  },true);
  // Enhance standard theme product cards (collection / search pages)
  function pick(media, featuredAlt){
    var fa=(featuredAlt||'').toLowerCase();
    var want=fa.indexOf('back')>-1?'front':'back';
    var swapped=want==='front'?fa.replace(/back/g,'front'):fa.replace(/front/g,'back');
    var imgs=media.filter(function(m){return m.media_type==='image';});
    var first=imgs[0]; var rest=imgs.slice(1);
    var o=rest.find(function(m){return (m.alt||'').toLowerCase()===swapped;})||rest.find(function(m){return (m.alt||'').toLowerCase().indexOf(want)>-1;});
    return o?{img:o,want:want}:null;
  }
  function enhance(card){
    if(card.dataset.pgFlipDone) return; card.dataset.pgFlipDone=1;
    var box=card.querySelector('.card__media .media'); if(!box||box.querySelector('[data-pg-flip]')) return;
    var a=card.querySelector('a[href*="/products/"]'); if(!a) return;
    var url=a.getAttribute('href').split('?')[0];
    fetch(url+'.js').then(function(r){return r.json();}).then(function(p){
      var media=p.media||[]; if(!media.length) return;
      var res=pick(media, media[0].alt); if(!res) return;
      Array.prototype.slice.call(box.querySelectorAll('img')).slice(1).forEach(function(i){i.remove();});
      var src=res.img.src||(res.img.preview_image&&res.img.preview_image.src); if(!src) return;
      var im=document.createElement('img');
      im.src=src+(src.indexOf('?')>-1?'&':'?')+'width=720'; im.loading='lazy'; im.alt=p.title+' — '+res.want;
      im.setAttribute('data-pg-alt',''); im.className='motion-reduce';
      box.appendChild(im);
      var b=document.createElement('button'); b.type='button'; b.className='pg-flip'; b.setAttribute('data-pg-flip','');
      var la=res.want==='back'?'Back':'Front', lb=res.want==='back'?'Front':'Back';
      b.dataset.labelA=la; b.dataset.labelB=lb; b.textContent=la; b.setAttribute('aria-label','Show '+res.want+' of '+p.title);
      box.appendChild(b); box.setAttribute('data-pg-flip-wrap','');
    }).catch(function(){});
  }
  function scan(){ document.querySelectorAll('.card-wrapper').forEach(enhance); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scan); else scan();
  new MutationObserver(function(){ scan(); }).observe(document.documentElement,{childList:true,subtree:true});
})();
